import { createFileRoute, getRouteApi } from "@tanstack/react-router"
import { Mail, MapPin, Phone } from "lucide-react"

import { InquiryForm } from "@/components/inquiry-form"

const rootRoute = getRouteApi("__root__")

export const Route = createFileRoute("/contact")({
  validateSearch: (search: Record<string, unknown>) => ({
    subject:
      typeof search.subject === "string"
        ? search.subject.slice(0, 120)
        : undefined,
  }),
  head: () => ({
    meta: [{ title: "Contact the demo desk · Harbor & Pine Realty" }],
  }),
  component: ContactPage,
})

function ContactPage() {
  const viewer = rootRoute.useLoaderData()
  const { subject } = Route.useSearch()
  return (
    <div className="field-container grid gap-10 py-14 lg:grid-cols-[0.85fr_1.15fr]">
      <section>
        <p className="field-label">General inquiry</p>
        <h1 className="field-heading mt-3">Ask the demo desk.</h1>
        <p className="mt-5 max-w-xl text-base leading-7 text-muted-foreground">
          Exercise the public-to-operations inquiry flow. No message leaves this
          fictional portal.
        </p>
        <div className="mt-10 divide-y border-y-2 border-foreground">
          {[
            [Mail, "Email", "hello@harborpine.demo"],
            [Phone, "Phone", "+1 555 010 4000"],
            [MapPin, "Office", "1 Fictional Quay, Harborview"],
          ].map(([Icon, label, value]) => (
            <div key={String(label)} className="flex items-center gap-4 py-5">
              <span className="grid size-10 place-items-center bg-secondary text-primary">
                <Icon className="size-5" />
              </span>
              <div>
                <p className="field-label">{String(label)}</p>
                <p className="mt-1 text-sm font-semibold">{String(value)}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-4 text-xs leading-5 text-muted-foreground">
          All contact details are reserved fictional examples and are not
          monitored.
        </p>
      </section>
      <section className="field-panel p-6 sm:p-8">
        <h2 className="font-heading text-3xl uppercase">Inquiry form</h2>
        <div className="mt-6">
          <InquiryForm
            viewer={viewer}
            defaultMessage={
              subject ? `I would like to ask about ${subject}.` : undefined
            }
          />
        </div>
      </section>
    </div>
  )
}
